export default "__VITE_ASSET__DOG$ctDw__"